/** Client PocketBase partagé (singleton). URL relative par défaut (même origine). */
import PocketBase from 'pocketbase';

// URL configurable pour les déploiements où l'API est sur une autre origine.
const baseUrl = import.meta.env.VITE_PB_URL ?? '/';

export const pb = new PocketBase(baseUrl);

// Auto-annulation désactivée : React Query gère les cycles de vie ; l'auto-cancel
// provoque des faux positifs lors des re-renders rapides.
pb.autoCancellation(false);

/** Utilisateur courant (ou null). */
export function currentUserId(): string | null {
  return pb.authStore.record?.id ?? null;
}
